import { PageRoutes } from "../constants/historyGaming";
import { NavigateFunction } from "react-router-dom";
export interface INavigate {
  replace?: boolean;
  destinationURL?: string;
  state?: unknown;
}

const back = (
  navigate: NavigateFunction,
  { replace, destinationURL }: INavigate = {},
) => {
  if (!window.history.state) {
    navigate(`/${PageRoutes.HomePage}`, {
      replace: true,
    });
  } else if (window.history.length > 2 && !destinationURL) {
    navigate(-1);
  } else {
    if (replace) {
      navigate(destinationURL || PageRoutes.HomePage, { replace: true });
    } else {
      navigate(destinationURL || PageRoutes.HomePage);
    }
  }
};

export const HistoryGaming = {
  back,
};
